import './App.css';
import { RouterProvider } from 'react-router';
import router from './router';
import AuthProvider from './Contexts/Providers/AuthProvider';
import { SnackbarProvider } from 'notistack';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { RycIsTheme } from './Shared/Theme/RycIsTheme';
import { ApiWithCallbackProvider } from './Api/useApiWithCallback';

function App() {
  return (
    <div className="App">
      <ThemeProvider theme={RycIsTheme}>
        <CssBaseline />
        <SnackbarProvider>
          <AuthProvider>
            <ApiWithCallbackProvider>
              <RouterProvider router={router} />
            </ApiWithCallbackProvider>
          </AuthProvider>
        </SnackbarProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
